var angularMaterialize = require('angular-materialize')
var angularRecaptcha = require('angular-recaptcha')
import angular from 'angular'
import 'angular-file-upload'
import 'angular-treasure-overlay-spinner/dist/treasure-overlay-spinner.min'

export var $candidatoMod = angular.module('candidato', [
  //
  'uniPanel', //
  angularMaterialize, //
  angularRecaptcha, //
  'angularFileUpload', //
  'treasure-overlay-spinner',
])
